import { render } from "./ProductCreate.vue?vue&type=template&id=7bb8a4ce&scoped=true"
import script from "./ProductCreate.js?vue&type=script&lang=js&external"
export * from "./ProductCreate.js?vue&type=script&lang=js&external"

import "./ProductCreate.scss?vue&type=style&index=0&id=7bb8a4ce&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb8a4ce"]])

export default __exports__